module.exports = __webpack_public_path__ + "img/ozon.b69007f8.png";